import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_GENERAL_SETTINGS_REGISTRATION_FIELDS_ROUTE_NAME = Symbol('admin.settings.registration-fields');
export const TRANSLATION_GROUP_GENERAL_SETTINGS_REGISTRATION_FIELDS = Symbol('general-settings.registration-fields');

export const SETTINGS_REGISTRATION_FIELDS_LIST_URL = 'admin/project_settings/required_fields_in_profile_update';
export const SETTINGS_REGISTRATION_FIELDS_SAVE_MUTATION_URL = 'admin/project_settings/:actionType_required_fields';

export const SETTINGS_REGISTRATION_FIELDS_LIST_QUERY_KEY = 'general-settings.registration-fields.list';
export const SETTINGS_REGISTRATION_FIELDS_SAVE_MUTATION_KEY = 'general-settings.registration-fields.save';

export const ADMIN_GENERAL_SETTINGS_REGISTRATION_FIELDS_PERMISSIONS = {
  PROJECTSETTINGS_REQUIRED_FIELDS_IN_PROFILE_UPDATE: new Permission(
    PermissionsList.admin.PROJECTSETTINGS_REQUIRED_FIELDS_IN_PROFILE_UPDATE,
  ),
};
